import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import { Grid, Box, TableContainer, Table, TableCell, TableBody, TableHead, TableRow,  Typography, useTheme, IconButton, Divider,  alpha } from '@mui/material';

import { tokens } from "../../../theme/theme";
import { FormControl } from '@mui/material';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import LinearProgress from '@mui/material/LinearProgress';

import { Checkbox } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Tooltip from '@mui/material/Tooltip';

import CustomSnackbar from '../../../components/CustomSnackbar';
import Button from '@mui/material/Button';

import { API_ENDPOINTS } from '../../../config/api/apiCall';


import dayjs from 'dayjs';

import GlobalConfig from '../../../components/GlobalConfig'; // Import your global configuration


import { AppBar, Toolbar, } from '@mui/material';
import { Menu, ListItemText } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
     MenuItem
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {  ListItemIcon } from "@mui/material";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import Close from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/HelpOutline';

import ImportExportIcon from '@mui/icons-material/ImportExport';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';


import { exportToExcel } from '../../../components/ExportToExcel';
import TableFilterRow from '../../../components/table/TableFilterRow';
import CustomTableContainer from '../../../components/table/CustomTableContainer';
import ModuleHelpDialog from '../../../components/ModuleHelpDialog';
import { ordertodm } from '../../../data/ordertodm';

const CoTODM = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [FromCODate, setFromCODate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToCODate, setToCODate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [isVisible_DespatchPlan, setisVisible_DespatchPlan] = useState(true);
    const [isVisible_CreateDespatchPlan, setisVisible_CreateDespatchPlan] = useState(true);
    const [isVisible_CreateDespatchPlanEntry, setiisVisible_CreateDespatchPlanEntry] = useState(false);
    const [isVisible_DespatchItem, setisVisible_DespatchItem] = useState(false);
    const [isVisible_commanButtons, setisVisible_commanButtons] = useState(false);
    const [isVisible_cancelDetail, setisVisible_cancelDetail] = useState(false);
    const [isVisiblebtnCreateDespatchPlan, setisVisiblebtnCreateDespatchPlan] = useState(true);
    const [isVisiblebtnAddSelectedCO, setisVisiblebtnAddSelectedCO] = useState(false);
    const [fromModule, SetfromModule] = useState('');
    const [fromSubModule, SetfromSubModule] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertsevierity, setalertsevierity] = useState('');
    const [progress, setProgress] = React.useState(0);
    const [buffer, setBuffer] = React.useState(10);
    const [loading, setLoading] = React.useState(false);
    const [rows, setTableData] = useState([]);
    const [rowsConfirmedOrders, setrowsConfirmedOrders] = useState([]);
    const [selectCOOrders, setselectCOOrders] = useState([]);
    const [Reason, SetReason] = useState('');
    const [SAmendmentReason, SetSAmendmentReason] = useState('');
    const [iConfirmationID, setiConfirmationID] = useState(0);
    const [totalSIConfirmedQty, set_totalSIConfirmedQty] = useState(0);
    const [totalGrossAmount, set_totalGrossAmount] = useState(0);
    const [totaldiscountAmount, settotaldiscountAmount] = useState(0);
    const [totalAmount, settotalAmount] = useState(0);
    const [iConfirmationIdList, set_iConfirmationIdList] = useState(0);

//help menu
const [helpOpen, setHelpOpen] = useState(false);
    const handleCloseHelp = () => setHelpOpen(false);
    const handleHelpMenuClick = () => setHelpOpen(true);

    const [gridAutoRows, setGridAutoRows] = useState(calculateGridAutoRows());
 
    let [FinancierYear, setFinancierYear] = useState(1);

    const [recordsPerPage, setRecordsPerPage] = useState(20); // Records per page
    const [currentPage, setCurrentPage] = useState(1);
 
 
    const LoadInoviceOrderList = () => {
        if (FromDate == null) {
            showError('Please select the from date', 'warning');
        } else if (ToDate == null) {
            showError('Please select the to date', 'warning');
        } else {
            setLoading(true); // Set loading state to true before fetching data

            const formattedFromDate = dayjs(FromDate).format('YYYY-MMM-DD');
            const formattedToDate = dayjs(ToDate).format('YYYY-MMM-DD');

            const requestBody = {
                SearchType: '',
                SearchString: '',
                SInvoiceNo: '',
                InvoiceDateFrom: formattedFromDate,
                InvoiceDateTo: formattedToDate,
                ConstructedGlobalValues: {
                    COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                    COMPANY_ID: localStorage.getItem('companyid'),
                },
            };

            fetch(API_ENDPOINTS.LoadInoviceOrderList, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Unable to load invoice order details');
                    }
                    return response.json();
                })
                .then(data => {
                    const formattedData = data.map((row, index) => {
                        const ShippedOrderDate = new Date(row.ShippedOrderDate).toLocaleDateString();
                        const InvoiceDate = new Date(row.InvoiceDate).toLocaleDateString();
                        return { ...row, id: index + 1, ShippedOrderDate, InvoiceDate };
                    });

                    setTableData(formattedData);
                })
                .catch(error => {
                    showError('Unable to load invoice order details', 'error');
                })
                .finally(() => {
                    setLoading(false); // Set loading state to false after fetching data
                });
        }
    };


    const LoadConfirmedOrderList = () => {
        if (FromCODate == null) {
            showError('Please select the from date', 'warning');
        } else if (ToCODate == null) {
            showError('Please select the to date', 'warning');
        } else {

            const formattedFromDate = dayjs(FromCODate).format('YYYY-MMM-DD');
            const formattedToDate = dayjs(ToCODate).format('YYYY-MMM-DD');

            const requestBody = {
                FromDate: formattedFromDate,
                ToDate: formattedToDate,
                ConstructedGlobalValues: {
                    COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                    COMPANY_ID: localStorage.getItem('companyid'),
                },
            };

            fetch(API_ENDPOINTS.GetConfirmedOrderListForDeckleMatching, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Unable to load confirmation order details');
                    }
                    return response.json();
                })
                .then(data => {
                    const formattedData = data.map((row, index) => {
                        const date = new Date(row.ConfirmationDate);

                        // Format to DD-MMM-YYYY
                        const dateOnly = date.toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric"
                        }).replace(/ /g, "-"); // replaces spaces with -

                        return { ...row, id: index + 1, dateOnly };
                    });


                    setrowsConfirmedOrders(formattedData);
                })
                .catch(error => {
                    showError('Unable to load confirmation order details', 'warning');
                });
        }
    };

    const showSnackbar = () => {
        setSnackbarOpen(true);
    };



    const handleFromCODate = (date) => {
        setFromCODate(dayjs(date));
        LoadConfirmedOrderList();
    };

    const handleToCODate = (date) => {
        setToCODate(dayjs(date));
        LoadConfirmedOrderList();
    };


    const handleCreateDispatchPlans = () => {
        setisVisible_CreateDespatchPlan(true);
        setisVisible_DespatchPlan(false);
        setiisVisible_CreateDespatchPlanEntry(false);
        setisVisible_commanButtons(false);
        setisVisible_DespatchItem(false);
        SetfromModule('Invoice Order List')

        setisVisiblebtnCreateDespatchPlan(true);
        setisVisiblebtnAddSelectedCO(false);
        setisVisible_cancelDetail(false);

        SetReason('');
        SetSAmendmentReason('');
    };


    const LoadConfirmationOrderDetailForDespatchOrder = async (requestBody) => {
        try {
            // Call the UploadSelectedItemsToDM API
            const response = await fetch(API_ENDPOINTS.UploadSelectedItemsToDM, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody),
            });

            if (!response.ok) {
                throw new Error('Unable to retrieve data from UploadSelectedItemsToDM');
            }

            const data = await response.json(); // This is your DataTable data

            // Now pass this data to the appropriate ProcessSalesOrderData API
            const result = await processSalesOrderData(data);

            if (result[0].status === 'SUCCESS') {
                const response = await fetch(API_ENDPOINTS.UpdateDMStatusInConfirmationItem, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(requestBody),
                });

                if (!response.ok) {
                    showError('Unable to retrieve data from UpdateDMStatusInConfirmationItem', 'error');
                    throw new Error('Unable to retrieve data from UpdateDMStatusInConfirmationItem');
                }

                showError('Data imported to deckle matching successfully..!', 'success');
                LoadConfirmedOrderList();
            }
            else {
                showError('Unable to Import the Orders to Deckle Matching', 'error');
            }
        } catch (error) {
            showError('Error: ' + error.message, 'error');
        }
    };

    const processSalesOrderData = async (data) => {
        try {
            const response = await fetch(API_ENDPOINTS.ProcessSalesOrderData, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                throw new Error('Unable to process sales order data');
            }

            const result = await response.json(); // Handle the result if needed
            console.log('ProcessSalesOrderData response:', result);
            return result; // Return the result here

        } catch (error) {
            showError('Error processing sales order data: ' + error.message, 'error');
        }
    };

    function validateForm() {
        let isFormDataValid = true;

        if (rowsConfirmedOrders.length === 0) {
            showError("Please select the order items to upload to deckle matching", "warning");
            return false;
        }
        return isFormDataValid;
    }

    const handleShowDispatchPlansEntry = () => {
        if (validateForm() !== false) {
            let selectedCOIdsNew = [];

            selectCOOrders.forEach((oItemRow) => {
                if (!selectedCOIdsNew.includes(parseInt(oItemRow.ConfirmationNoItemID))) {
                    selectedCOIdsNew.push(parseInt(oItemRow.ConfirmationNoItemID));
                }
            });

            setiConfirmationID(selectedCOIdsNew);

            if (selectedCOIdsNew.length === 0) {
                showError('Please select the order items to upload to deckle matching', 'warning');
                return;
            }

            const sListCOIDs = selectedCOIdsNew.join(',');
            set_iConfirmationIdList(sListCOIDs);

            if (sListCOIDs !== "") {
                const requestBody = {
                    SSelectedCOIDList: sListCOIDs,
                    ConstructedGlobalValues: {
                        COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                        COMPANY_ID: 98 //harcoded for upload to web //localStorage.getItem('companyid'),
                    },
                };
                LoadConfirmationOrderDetailForDespatchOrder(requestBody);
            }
        }

    };




    const handleBackTofromDespacthPlanEntry = () => {
        setisVisible_CreateDespatchPlan(false);
        setisVisible_DespatchPlan(false);
        setiisVisible_CreateDespatchPlanEntry(false);
        setisVisible_commanButtons(false);
        setisVisible_DespatchItem(false);

        if (fromModule === 'Invoice Order List') {
            setisVisible_DespatchPlan(true);
        }
        else if (fromModule === 'Invoice Ordes') {
            setisVisible_CreateDespatchPlan(true);
        }
        else if (fromSubModule === 'Despatch Plan Entry') {
            setiisVisible_CreateDespatchPlanEntry(true);
            setisVisible_commanButtons(true);
            SetfromSubModule('');
        }
    }



    const handleBackTofromConnfrimOrderList = () => {
        setisVisible_CreateDespatchPlan(false);
        setiisVisible_CreateDespatchPlanEntry(false);
        setisVisible_commanButtons(false);
        setisVisible_DespatchItem(false);
        setisVisible_DespatchPlan(true);
    }

    const CalculateSummaryForProducts = () => {
        let totalSIConfirmedQty = 0;
        let totalGrossAmount = 0;
        let oTotalDiscountAmount = 0;

        rowsConfirmedOrdersDespacth.forEach((row) => {
            const newRowSIConfirmedQty = parseFloat(row.SIConfirmed_Qty);
            const newRowSIUnitPrice = parseFloat(row.SIUnitPrice);
            const newRowSIDiscount = parseFloat(row.SIDiscount);
            const DiscountType = row.SIDiscountType;

            if (newRowSIDiscount > 0) {
                if (DiscountType === 'rate') {
                    oTotalDiscountAmount += newRowSIConfirmedQty * ((newRowSIUnitPrice * newRowSIDiscount) / 100)
                }
                else {
                    oTotalDiscountAmount += newRowSIConfirmedQty * newRowSIDiscount
                }
            }
            totalSIConfirmedQty += newRowSIConfirmedQty;
            totalGrossAmount += newRowSIConfirmedQty * newRowSIUnitPrice;
        });

        // Set the totals in the state
        set_totalSIConfirmedQty(totalSIConfirmedQty);
        set_totalGrossAmount(totalGrossAmount);
        settotaldiscountAmount(oTotalDiscountAmount);
        settotalAmount(oTotalDiscountAmount);
    }


    const [rowsConfirmedOrdersDespacth, setrowsConfirmedOrdersDespacth] = useState([]);

    const [rowsReelItems, setrowsReelItems] = useState([]);
    const [rowsSheetItems, setrowsSheetItems] = useState([]);
    const [rowsReelItemsFiltered, setrowsReelItemsFiltered] = useState([]);
    const [rowsSheetItemsFiltered, setrowsSheetItemsFiltered] = useState([]);


    useEffect(() => {
        const handleResize = () => {
            setGridAutoRows(calculateGridAutoRows());
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        CalculateSummaryForProducts();
    });


    useEffect(() => {
        LoadInoviceOrderList();
        LoadConfirmedOrderList();

    }, []);

    function calculateGridAutoRows() {
        const screenHeight = window.innerHeight;
        const rows = Math.floor((screenHeight - 70) / 3); // Adjust 50 as needed for margins or paddings
        return `${rows}px`;
    }




  
    const showError = (message, severity) => {
        setAlertMessage(message);
        setalertsevierity(severity);
        showSnackbar();
        return true;
    };



    const handleSubmitConfirmationOrder = (event) => {
        event.preventDefault();

        if (FromCODate == null) {
            showError('Please select the from date', 'warning');
        }
        else if (ToCODate == null) {
            showError('Please select the to date', 'warning');
        }
        else {
            LoadConfirmedOrderList();
        }
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const handleKeyPress = (event) => {
        if (event.altKey && event.key.toLowerCase() === 'c') {
            handleCreateDispatchPlans();
        }
        if (event.altKey && event.key.toLowerCase() === 'p') {
            handleBackTofromConnfrimOrderList();
        }
        if (event.altKey && event.key.toLowerCase() === 'n') {
            handleShowDispatchPlansEntry();
        }
        if (event.altKey && event.key.toLowerCase() === 'b') {
            handleBackTofromDespacthPlanEntry();
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleCreateDispatchPlans, handleBackTofromConnfrimOrderList, handleShowDispatchPlansEntry, handleBackTofromDespacthPlanEntry]);


    const handleCheckboxChangeForConfirmationOrder = (event, rowId) => {
        const updatedRows = rowsConfirmedOrders.map(row =>
            row.id === rowId ? { ...row, SelectItem: event.target.checked } : row
        );
        setrowsConfirmedOrders(updatedRows);

        const filteredData = updatedRows.filter(row => row.SelectItem === true);
        setselectCOOrders(filteredData);
    };

    const [selectedStatus, setSelectedStatus] = useState('All');
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedRows_orders, setSelectedRows_orders] = useState([]);

    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    const openFirst = Boolean(anchorElFirst);
    const openSecond = Boolean(anchorElSecond);
    const [showNewToolbar, setShowNewToolbar] = useState(false);
    const [showFirstToolbar, setShowFirstToolbar] = useState(true);
    const [open1, setOpen1] = useState(false);

    const isSelected1_order = (rowId) => selectedRows_orders.indexOf(rowId) !== -1;

    const [filters, setFilters] = useState({
        ProductGroup: '',
        ProductSubGroup: '',
        ProductVariety: '',
        Code: '',
        Name: '',
    });

    const filteredData_orders = rowsConfirmedOrders.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.InvoiceStatus === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

 
    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        handleMenuCloseSecond();
    };


    const handleFilterChange = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };

    const handleRowCheckboxClickDeliveryOrder = (event, rowId) => {
        const selectedIndex = selectedRows_orders.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows_orders, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows_orders.slice(1);
        } else if (selectedIndex === selectedRows_orders.length - 1) {
            newSelectedRows = selectedRows_orders.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows_orders.slice(0, selectedIndex),
                ...selectedRows_orders.slice(selectedIndex + 1),
            ];
        }

        setSelectedRows_orders(newSelectedRows);

        if (newSelectedRows.length > 0) {
            setShowNewToolbar(true); // Show new toolbar when rows are selected
            setShowFirstToolbar(false);
        }
        else {
            setShowNewToolbar(false); // Hide new toolbar when no rows are selected
            setShowFirstToolbar(true);
        }

        handleCheckboxChangeForConfirmationOrder(event, rowId)
    };



    const handleBackDashboard = () => {
        // navigate("/");
        handleBackWinderMachineEntry();
    }

    const excelColumns = [
        { header: "CO.No.", key: "ConfirmationNo" },
        { header: "LineNo", key: "LineNo" },
        { header: "Item Status", key: "LineItemStatus" },
        { header: "CO Date", key: "dateOnly" },
        { header: "Bill-to Party", key: "BillToCustomerName" },
        { header: "Ship-to Party", key: "ShipToCustomerName" },
        { header: "Item Remarks", key: "LineItemRemarks" },
        { header: "Variety Code", key: "Variety" },
        { header: "BF", key: "BF" },
        { header: "GSM", key: "GSM" },
        { header: "Width", key: "Width" },
        { header: "Length", key: "Length" },
        { header: "CO.Qty", key: "ConfirmedQty" },
        { header: "QtyInStock", key: "QtyInStockForOrder" },
        { header: "PendingQty", key: "PendingQty" },
        { header: "Avail.QtyInSWO", key: "AvailableQtyInSWO" },
        { header: "Grain", key: "GrainDirection" },
        { header: "Package Mode", key: "PackageMode" },

    ];

    const dateColumnIndexes = [3]; // "DATE"
    const numberColumnIndexes = [1, 9, 10, 11, 12, 13, 14, 15,]; // "REEL", "SHEET WT.", "REAM WT.", "BUNDLE WT.", "FG"


    const handleExportToExcel = () => {
        exportToExcel({
            data: filteredData_orders,
            fileName: 'COForDeckleReport.xlsx',
            sheetName: 'COList',
            columns: excelColumns,           // 🔁 Fixed name
            dateColumnIndexes,
            numberColumnIndexes

        });
    };


    const uniqueValues = {
        ConfirmationNo: [...new Set(rowsConfirmedOrders.map(row => row.ConfirmationNo))],
        LineItemStatus: [...new Set(rowsConfirmedOrders.map(row => row.LineItemStatus))],
        BillToCustomerName: [...new Set(rowsConfirmedOrders.map(row => row.BillToCustomerName))],
        ShipToCustomerName: [...new Set(rowsConfirmedOrders.map(row => row.ShipToCustomerName))],
        LineItemRemarks: [...new Set(rowsConfirmedOrders.map(row => row.LineItemRemarks))],
        Variety: [...new Set(rowsConfirmedOrders.map(row => row.Variety))],
        GSM: [...new Set(rowsConfirmedOrders.map(row => row.GSM))],
        GrainDirection: [...new Set(rowsConfirmedOrders.map(row => row.GrainDirection))],

    };


    // Get the records for the current page
    const currentRecords = filteredData_orders.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );

    const columns = ['', 'ConfirmationNo', 'LineNo', 'LineItemStatus', 'dateOnly', 'BillToCustomerName', 'ShipToCustomerName', 'LineItemRemarks', 'Variety', 'BF', 'GSM', 'Width', 'Length', 'ConfirmedQty', 'QtyInStockForOrder', 'PendingQty', 'AvailableQtyInSWO', 'GrainDirection', 'PackageMode'];

    const autoCompleteColumns = ['', 'ConfirmationNo', 'LineItemStatus', 'BillToCustomerName', 'ShipToCustomerName', 'LineItemRemarks', 'Variety', 'GSM', 'GrainDirection',];

    const totals = {
        ConfirmedQty: filteredData_orders.reduce((sum, r) => sum + (parseFloat(r.ConfirmedQty) || 0), 0),
        QtyInStockForOrder: filteredData_orders.reduce((sum, r) => sum + (parseFloat(r.QtyInStockForOrder) || 0), 0),
        PendingQty: filteredData_orders.reduce((sum, r) => sum + (parseFloat(r.PendingQty) || 0), 0),
        AvailableQtyInSWO: filteredData_orders.reduce((sum, r) => sum + (parseFloat(r.AvailableQtyInSWO) || 0), 0),

    };

    return (
        <Box  >




            {loading && (
                <Box sx={{ width: '100%', marginTop: '10px' }}>
                    <LinearProgress
                        variant="buffer"
                        sx={{
                            '& .MuiLinearProgress-barColorPrimary': {
                                backgroundColor: '#4CAF50', // Green color (you can replace this with your desired color)
                            },
                            '& .MuiLinearProgress-bar2Buffer': {
                                backgroundColor: '#8BC34A', // Another shade of green for the buffer
                            },
                        }}
                        value={progress}
                        valueBuffer={buffer}
                    />
                </Box>
            )}


            {isVisible_CreateDespatchPlan && (

                <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                    <Toolbar>


                        <Button
                            color="secondary"
                            onClick={handleMenuClickFirst}
                            endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                            sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                        >
                            Confirmation Orders To DM
                        </Button>


                        {/* Spacer to push buttons to the right */}
                        <Box sx={{ flexGrow: 1 }} />

                        <Tooltip title="Upload to Optrim Deckle matching" >
                            {isVisiblebtnCreateDespatchPlan && (
                                <Button size="small" variant="contained" onClick={handleShowDispatchPlansEntry} color="secondary" startIcon={<FileUploadIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Upload to Optrim</Button>
                            )}
                        </Tooltip>


                        {/* Second Menu */}
                        <IconButton
                            size="small"
                            aria-label="menu"
                            sx={{ ml: 2 }}
                            onClick={handleMenuClickSecond}
                        >
                            <MoreVertIcon />
                        </IconButton>

                        <Menu
                            anchorEl={anchorElSecond}
                            open={openSecond}
                            onClose={handleMenuCloseSecond}
                        >
                            <MenuItem onClick={() => handleMenuItemClickSecond('Import Items')}>
                                <ListItemIcon>
                                    <ImportExportIcon />
                                </ListItemIcon>
                                <ListItemText primary="Import Items" />
                            </MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickSecond('Export Items')}>
                                <ListItemIcon>
                                    <FileDownloadIcon />
                                </ListItemIcon>
                                <ListItemText primary="Export Items" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                                <ListItemIcon>
                                    <ViewColumnIcon />
                                </ListItemIcon>
                                <ListItemText primary="Export Current View" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                <ListItemIcon>
                                    <ListAltIcon />
                                </ListItemIcon>
                                <ListItemText primary="Preference " />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                <ListItemIcon>
                                    <RefreshIcon />
                                </ListItemIcon>
                                <ListItemText primary="Refresh List" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>
                                <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                    Reset Columns Width
                                </Button>
                            </MenuItem>
                        </Menu>

                        <IconButton
                            size="small"
                            aria-label="menu"
                            sx={{ mr: 1, ml: 1 }}
                            onClick={handleHelpMenuClick}
                        >
                            <HelpIcon />
                        </IconButton>
                         <ModuleHelpDialog
                   open={helpOpen}
                     onClose={handleCloseHelp}
                    data={ordertodm.ordertodm}
                     />

                        <div>
                            <IconButton>
                                <Close fontSize="inherit" style={{ color: "#2196F3" }} onClick={handleBackDashboard} />
                            </IconButton>
                        </div>
                    </Toolbar>
                </AppBar>

            )}
            <CustomSnackbar
                open={snackbarOpen}
                message={alertMessage}
                onClose={handleSnackbarClose}
                type={alertsevierity}
            />


            {isVisible_CreateDespatchPlan && (
                <form onSubmit={handleSubmitConfirmationOrder}>
                    <Box>
                        <Grid container spacing={0}>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >


                                <Grid container padding="5px 0px 5px 5px" alignItems="center" sx={{ mt: 0, mb: 0, pt: 0, pb: 0, justifyContent: "flex-end" }} >

                                    <Grid item lg={1.3} xl={1.3}>
                                        <Typography ml={1} style={{ fontSize: '14px' }}> Filter By : CO Date </Typography>
                                    </Grid>

                                    <Grid item mr="10px">
                                        <Typography fontWeight="bold">|</Typography>
                                    </Grid>

                                    <Grid item xs={2} sm={3} md={1.5} lg={1.5} xl={1.5} mt="5px">
                                        <FormControl fullWidth size="small">
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    style={{ marginLeft: '10px' }}
                                                    id="FromCODate"
                                                    value={dayjs(FromCODate)}
                                                    onChange={(date) => handleFromCODate(date)}

                                                    slotProps={{
                                                        textField: {
                                                            size: 'small',
                                                            variant: 'standard', // Removes the filled/outlined border
                                                            InputProps: {
                                                                disableUnderline: true, // Remove underline from 'standard' variant
                                                            },
                                                            sx: {
                                                                backgroundColor: 'transparent',
                                                                padding: 0,
                                                                '& .MuiInputBase-root': {
                                                                    border: 'none',
                                                                },
                                                                '& .MuiSvgIcon-root': {
                                                                    fontSize: '18px', // 👈 smaller icon size
                                                                },
                                                                '& .MuiInputBase-root': {
                                                                    paddingRight: '6px', // optional: reduce padding around icon
                                                                },
                                                            },
                                                        }
                                                    }}
                                                    renderInput={(props) => <TextField {...props} />}
                                                    autoFocus
                                                    format="DD-MMM-YYYY"
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>

                                    <Grid item mr="10px" ml="5px">
                                        <Typography fontWeight="bold">|</Typography>
                                    </Grid>

                                    <Grid item xs={2} sm={3} md={1.5} lg={1.5} xl={1.5} mt="5px" mr="10px">
                                        <FormControl fullWidth size="small" >
                                            <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                                <DatePicker
                                                    id="ToCODate"
                                                    value={dayjs(ToCODate)}
                                                    format="DD-MMM-YYYY"
                                                    onChange={(date) => handleToCODate(date)}
                                                    // slotProps={{ textField: { size: 'small', } }}
                                                    slotProps={{
                                                        textField: {
                                                            size: 'small',
                                                            variant: 'standard', // Removes the filled/outlined border
                                                            InputProps: {
                                                                disableUnderline: true, // Remove underline from 'standard' variant
                                                            },
                                                            sx: {
                                                                backgroundColor: 'transparent',
                                                                padding: 0,
                                                                '& .MuiInputBase-root': {
                                                                    border: 'none',
                                                                },
                                                                '& .MuiSvgIcon-root': {
                                                                    fontSize: '18px', // 👈 smaller icon size
                                                                },
                                                                '& .MuiInputBase-root': {
                                                                    paddingRight: '6px', // optional: reduce padding around icon
                                                                },
                                                            },
                                                        }
                                                    }}
                                                    renderInput={(props) => <TextField {...props} />}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>

                                    <Grid item mr="10px" ml="5px">
                                        <Typography fontWeight="bold">|</Typography>
                                    </Grid>

                                    <Grid item mt="2px">
                                        <Tooltip title="Download CO List" onClick={handleExportToExcel}>
                                            <IconButton >
                                                <FileDownloadIcon color='secondary' />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                </Grid>

                                <CustomTableContainer colors={colors}>
                                    <TableContainer>
                                        <Table size="small">
                                            <TableHead sx={{ height: 10 }}>
                                                <TableRow>
                                                    <TableCell>
                                                        {/* <Checkbox
                                                            size="small"
                                                            color="secondary"
                                                            indeterminate={selectedRows_orders.length > 0 && selectedRows_orders.length < rowsConfirmedOrders.length}
                                                            checked={selectedRows_orders.length === rowsConfirmedOrders.length}
                                                            onChange={handleSelectAllClick}
                                                        /> */}
                                                    </TableCell>
                                                    <TableCell sx={{  minWidth: 120, whiteSpace: "nowrap" }}>CO.NO</TableCell>
                                                    <TableCell style={{ minWidth: "80px" }}>LINO NO</TableCell>
                                                    <TableCell style={{ minWidth: "100px" }}>ITEM STATUS</TableCell>
                                                    <TableCell style={{ minWidth: "120px" }}>CO DATE</TableCell>
                                                    <TableCell style={{textAlign: "center",minWidth: 200, whiteSpace: "nowrap"  }}>BILL TO PARTY</TableCell>
                                                    <TableCell style={{ textAlign: "center",minWidth: 200 ,whiteSpace: "nowrap" }}>SHIP TO PARTY</TableCell>
                                                    <TableCell style={{ minWidth: "120px" }}>ITEM REMARKS</TableCell>
                                                    <TableCell style={{ minWidth: "120px" }}>VARIETY CODE</TableCell>
                                                    <TableCell>BF</TableCell>
                                                    <TableCell>GSM</TableCell>
                                                    <TableCell>WIDTH</TableCell>
                                                    <TableCell>LENGTH</TableCell>
                                                    <TableCell>CO.QTY</TableCell>
                                                    <TableCell>QTYINSTOCK</TableCell>
                                                    <TableCell>PENDINGQTY</TableCell>
                                                    <TableCell>AVAIL.QTYINSWO</TableCell>
                                                    <TableCell>GRAIN</TableCell>
                                                    <TableCell sx={{ textAlign: "center", minWidth: 120, whiteSpace: "nowrap" }}>PACKAGE MODE</TableCell>

                                
                                                </TableRow>

                                                <TableFilterRow
                                                    columns={columns}
                                                    filters={filters}
                                                    handleFilterChange={handleFilterChange}
                                                    uniqueValues={uniqueValues}
                                                    autoCompleteColumns={autoCompleteColumns}
                                                />


                                                <TableRow sx={{ backgroundColor: colors.primary[400], height: 10 }}>
                                                    <TableCell colSpan={13} sx={{ fontWeight: 'bold', textAlign: 'right' }}>TOTAL </TableCell>
                                                    <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.ConfirmedQty.toFixed(2)}</TableCell>
                                                    <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.QtyInStockForOrder.toFixed(2)}</TableCell>
                                                    <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.PendingQty.toFixed(2)}</TableCell>
                                                    <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.AvailableQtyInSWO.toFixed(2)}</TableCell>

                                                    <TableCell />
                                                    <TableCell />

                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {currentRecords.map((row, index) => (
                                                    <TableRow key={row.id}
                                                        sx={{
                                                            backgroundColor:
                                                                index % 2 === 0
                                                                    ? theme.palette.background.default
                                                                    : alpha(theme.palette.action.hover, 0.04), // slightly darker
                                                        }}

                                                        selected={isSelected1_order(row.id)}>
                                                        <TableCell>
                                                            <Checkbox
                                                                size="small"
                                                                checked={isSelected1_order(row.id)}
                                                                onChange={(event) => handleRowCheckboxClickDeliveryOrder(event, row.id)}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            {/* <span
                                                                style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                            // onClick={() => handleOnCellClick_DespatchPlanList(row)}
                                                            >
                                                                {row.ConfirmationNo}
                                                            </span> */}
                                                            {row.ConfirmationNo}
                                                        </TableCell>
                                                        <TableCell>{row.LineNo}</TableCell>
                                                        <TableCell>{row.LineItemStatus}</TableCell>
                                                        <TableCell>{row.dateOnly}</TableCell>
                                                        <TableCell  >{row.BillToCustomerName}</TableCell>
                                                        <TableCell >{row.ShipToCustomerName}</TableCell>
                                                        <TableCell>{row.LineItemRemarks}</TableCell>
                                                        <TableCell>{row.Variety}</TableCell>
                                                        <TableCell>{row.BF}</TableCell>
                                                        <TableCell>{row.GSM}</TableCell>
                                                        <TableCell>{row.Width}</TableCell>
                                                        <TableCell>{row.Length}</TableCell>
                                                        <TableCell>{row.ConfirmedQty}</TableCell>
                                                        <TableCell>{row.QtyInStockForOrder}</TableCell>
                                                        <TableCell>{row.PendingQty}</TableCell>
                                                        <TableCell>{row.AvailableQtyInSWO}</TableCell>
                                                        <TableCell>{row.GrainDirection}</TableCell>
                                                        <TableCell>{row.PackageMode}</TableCell>
                                                        {/* <TableCell>{row.NoOfSheets}</TableCell>
                                                        <TableCell>{row.ReamWeight}</TableCell>
                                                        <TableCell>{row.ReelOD}</TableCell> */}

                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </CustomTableContainer>




                            </Grid>
                        </Grid>
                    </Box>
                </form>
            )}




        </Box >
    );
};

export default CoTODM;